/** True op clientportal-hostnaam of `?clientportal=true` (zelfde logica als elders in de app). */
export function isClientPortalHostname(): boolean {
  if (typeof window === 'undefined') return false;
  return (
    window.location.hostname.toLowerCase().includes('clientportal') ||
    new URLSearchParams(window.location.search).get('clientportal') === 'true'
  );
}
